import {generateId, replaceUnsupportedSymbols} from 'js/helpers/generate';

/**
 * Parses apartment string to object matching the requested structure.
 * Input: "2,1:3,,FVeO6gkunH" (Adults, ChildrenCount:Age, Babies, ID)
 * Output: { adults: 2, children: 1, childrenAges: [3], babies: 0, id: '...' }
 */
export const parseApartment = (str) => {
  if (!str) return null;

  const parts = str.split(',');
  const adults = parseInt(parts[0], 10) || 1;

  // Children parsing
  const childrenPart = parts[1] || '';
  const childrenSplit = childrenPart.split(':');
  const childrenCount = parseInt(childrenSplit[0], 10) || 0;

  const childrenAge = childrenCount > 0 && childrenSplit.length > 1
    ? (childrenSplit[1] || '').split('-').map(age => parseInt(age, 10))
    : [];

  const babies = parts[2] === '' ? 0 : parseInt(parts[2], 10);
  const id = !!parts[3] ? replaceUnsupportedSymbols(parts[3]) : generateId();

  return {
    adults,
    children: childrenCount,
    childrenAge,
    babies,
    id
  };
};

/**
 * Serializes object back to string
 */
export const serializeApartment = (apt) => {
  if (!apt) return '';

  const adults = apt.adults || 1;
  const babies = apt.babies || '0';
  const id = apt.id || generateId();

  // Serialize children part: "count:age1:age2"
  let childrenStr = '0';
  if (apt.children > 0 && apt.childrenAge && apt.childrenAge.length > 0) {
    childrenStr = `${apt.children}:${apt.childrenAge.join('-')}`;
  } else if (apt.children > 0) {
    childrenStr = `${apt.children}`; // Case where count > 0 but no ages provided (edge case)
  }

  return `${adults},${childrenStr},${babies},${id}`;
};

export const generateNewApartmentObj = function () {
  return {
    adults: 2,
    children: 0,
    babies: 0,
    id: generateId(),
  };
};
